import { render, staticRenderFns } from "./page9.vue?vue&type=template&id=b3cafe20&scoped=true&"
import script from "./page9.vue?vue&type=script&lang=js&"
export * from "./page9.vue?vue&type=script&lang=js&"
import style0 from "./page9.vue?vue&type=style&index=0&lang=less&"
import style1 from "./page9.vue?vue&type=style&index=1&id=b3cafe20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cafe20",
  null
  
)

export default component.exports